import React from 'react';

import adressFrankfurt from '../../assets/images/locations/maps/gmaps-frankfurt.png';
import adressPrague from '../../assets/images/locations/maps/gmaps-prague.png';
import adressSofia from '../../assets/images/locations/maps/gmaps-sofia.png';
import adressLodz from '../../assets/images/locations/maps/gmaps-lodz.png';

import {locationAddressData} from './locationAddressData';
import {isMobile} from 'react-device-detect';

const LocationAddress = ({selectedLocation}) => {
    const getVenueImage = (selectedLocation) => {
        switch (selectedLocation) {
            case 'Frankfurt':
                return adressFrankfurt;
            case 'Prague':
                return adressPrague;
            case 'Łódź':
                return adressLodz;
            case 'Sofia':
                return adressSofia;
            default:
                return 'none';
        }
    };

    const locationData = locationAddressData.find(
        (item) => item.location === selectedLocation
    ).info
    const buttonContent = locationData.map(data => <>
        {data.extraInfo && (
            <div className="sm:text-lg">
                {
                    data.extraInfo
                }
            </div>
        )}
        <div className="font-bold sm:text-lg">
            {
                data.venueName
            }
        </div>
        <div className="sm:text-lg">
            {
                data.addressLine1
            }
        </div>
        <div className="sm:text-lg">
            {
                data.addressLine2
            }
        </div>
        <div className="mx-auto w-52 my-3.5">
            <a
                className="p-2 rounded-lg cursor-pointer bg-secondary1 text-white hover:bg-primary2"
                href={
                    data.gmapsLink
                }
                target="_blank"
                rel="norefferer noreferrer"
            >
                view on google maps
            </a>
        </div>
    </>)
    return (
        <>
            <div className="relative">
                <img
                    className="w-full object-cover h-[512px] object-center rounded-xl"
                    src={getVenueImage(selectedLocation)}
                    alt={'Address of the Venue'}
                />
                <div
                    className={isMobile ? "absolute  inset-0 flex justify-center " : "absolute top-[24px] left-[24px] justify-center align-middle"}>
                    <div
                        className={`w-64 ${
                            selectedLocation === 'Prague' ? 'h-48' : 'h-40'
                        } md:w-96 bg-gray-100 rounded-lg p-4 text-center`}
                    >
                        {buttonContent[0]}
                    </div>
                </div>
                {buttonContent[1] && (
                    <div
                        className={isMobile ? "absolute  inset-x-0 flex justify-center -bottom-10" : "absolute bottom-[24px] left-[24px] justify-center align-middle"}>
                        <div
                            className={`w-64 ${
                                selectedLocation === 'Prague' ? 'h-48' : 'h-40'
                            } md:w-96 bg-gray-100 rounded-lg p-4 text-center`}
                        >
                            {buttonContent[1]}
                        </div>
                    </div>
                )}

            </div>
        </>
    );
};

export default LocationAddress;
